import React, { useEffect, useState }  from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactTableServerSide } from '../../ReactTableServerSide';
import Typography from '@mui/material/Typography';
import {GPAP_Button_light} from "../../../../gpap-lib/Button_Collection";
import Box from '@mui/material/Box';
import auth from '../../../service/Auth';
import { CsvButton,downloadCSV } from '../../../service/CsvButton';
import {detailed_data_access} from '../../../service/apis';
import settings from '../../../DataManagementConfig';
import ViewError from '../components/ViewError';

const config = window.config;

const DetailedStaticsDataAccess = (props) => {

    const [headers, setHeaders] = useState([]);
    const [data, setData] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const [errors, setErrors] = useState("");
    const [headersTable, setHeadersTable] = useState([]);
    const [rowsTable, setRowsTable] = useState([]);
    const [pagination, setPagination] = useState({});
    const [experimentID, setExperimentID] = useState("");

    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setErrors("Logging session timeout. Please log again");
        }
        else {
            // Headers setup
            setHeaders([
                { label: "User" , key: "user"},
                { label: "Sample" , key: "sample",tooltip: "Query's Experiment ID." },
                { label: "Type of Query" , key: "query_type"},
                { label: "Date" , key: "date" }
            ]);
            // Initialize Pagination 
            setPagination({
                page: 0, pages: 0,
                pageSize: settings.basicPageSize,
                totalItems: 0, fields: [],
                filtered: [], sorted: []
            });
            setExperimentID(props.match.params.experiment_id);
        }
    },[])

    const getTableHeaders = () => {
        //Build data to render on react-table
        let columns = []
        for (let header of headers) {
            let column = {};
            if ("tooltip" in header){
                column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
            }
            else{
                column["Header"] = header.label;
            }

            if (header.key === "sample"){
              column["filterable"] = false;
              column["sortable"] = false;
            }

            column["accessor"] = header.key;
            column["minWidth"] = 220;
            columns.push(column);
        }
        //Update data
        setHeadersTable(columns);
    }
 
    const getDataTable = () => {
        //If data is not still collected then return empty rows
        let rows = [];
        if (data === undefined) setRowsTable([]);
        // Loop over group_stats objects to render the table contents
        if (Array.isArray(data)){
            for (let row_contents of data) {
                let row = {};
                Object.entries(row_contents).forEach(([key,value]) => { row[key] = value });
                // Add row to data
                rows.push(row);
            }
        }
        setRowsTable(rows);
    }

    const loadTableData = (state, instance) => {
        // Method to call API Endpoint to get Table View Data
        // Update Loading Status
        setLoadData(true);
        // Get fields to be requiered
        let fields = [];
        for (let header of headers) {
            fields.push(header.key);
        }
        // Build POST endpoint
        let body = {
            "page" : (state.page + 1),
            "pageSize" : state.pageSize,
            "fields": fields,
        };
        // Check filtered Criteria
        if (state.filtered && state.filtered.length > 0) {
            body["filtered"] = state.filtered.map( item => ( { id:item.id, value:item.value} ) );
            body["filtered"].push({"id": "sample", "value": props.match.params.experiment_id})
        } else {
            body["filtered"] = [{"id": "sample", "value": props.match.params.experiment_id}];
        }
        // Check sorted Criteria
        if (state.sorted) {
            body["sorted"] = state.sorted;
        }
        /* Call POST Data*/
        detailed_data_access(auth.getToken(),config.api_endpoint, JSON.stringify(body))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            if (typeof data === 'object') {
                setData(data['items']);
                setPagination({
                    page: data['_meta']['page'],
                    pages: data['_meta']['total_pages'],
                    pageSize: data['_meta']['page_size'],
                    totalItems: data['_meta']['total_items'],
                    fields: fields,
                    filtered: body.filtered,
                    sorted: body.sorted
                });
            }
            setLoadData(false);
        });
    };

    useEffect(() => {
        // Set headers
        getTableHeaders();
    },[data])

    useEffect(() => {
        // Set rows
        getDataTable();
    },[headersTable])

    const closeModal = () => {
        setErrors("");
    }

    const getCsvData = async (events) => {
        /*Get All Data to be printed to CSV Files*/
        let data_query = {
            "page" : 1,
            "pageSize" : settings.apiExperimentCSVPageSize,
            "fields" : pagination.fields,
            "filtered" : pagination.filtered.map( item => ( { id:item.id, value:item.value} ) ),
            "sorted": pagination.sorted
        };
        let getData = true;
        let allItems = [];
        /*Get All Data*/
        while (getData){
             /* Call POST Data*/
             await detailed_data_access(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
             .then((response) => {
                return response.json()
             })
             .then((data) => {
                 if (typeof data === 'object') {
                     allItems.push(...data["items"]);
                     if (data_query.page < data["_meta"]["total_pages"]){
                         getData = true;
                         data_query.page = data_query.page + 1;
                     }
                     else getData = false;
                 } else {
                     getData = false;
                 }
             });
        }
        //Build data for CSV
        let contents = [];
        for (let item of allItems){
            let row = {};
            Object.entries(item).forEach(([key,value]) => {
              if (typeof value === "boolean") row[key] = value.toString();
              else row[key] = value;
            });
            // Add row to data
            contents.push(row);
        }
        //Trigger Download CSV
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(contents,headers,`${today}_detailed_statics_data_access.csv`);
    }

    if (errors !== "") {
        // Show popup in case an error with the loggin occurs 
        return <ViewError closeModal={closeModal} title={"Logging Error"} message={errors}/>;
    }
    else {
        return (
            <div className={"mainContent"}>
                <Typography variant={"h5"} align={"center"}> 
                    Detailed Statistics on Experiment Access for  {experimentID} 
                </Typography>

                <Box p={2}>
                    <Box p={1} style={{float:"left"}}>
                        <GPAP_Button_light href = "#/staticdataaccess"  startIcon={<ArrowBackIcon />}>
                            Back
                        </GPAP_Button_light>
                    </Box>
                    <Box p={0} style={{float:"left"}}>
                        <CsvButton getCsvData={getCsvData} />
                    </Box>
                </Box >

                <ReactTableServerSide
                    headers={headers}
                    columns={headersTable}
                    data={rowsTable}
                    pagination={ pagination }
                    loadTableData={loadTableData}
                    fieldsDelay={headers.map(header => header.key)}
                    loading={loadData}
                />
            </div>
        );
    }
}

export default DetailedStaticsDataAccess;